import { render, staticRenderFns } from "./community-vision.vue?vue&type=template&id=22ff41bf&scoped=true&"
import script from "./community-vision.vue?vue&type=script&lang=js&"
export * from "./community-vision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff41bf",
  null
  
)

export default component.exports